var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" Oops! Something went wrong. Please check the URL you are visiting or refresh your page ")])
}
var staticRenderFns = []

export { render, staticRenderFns }